import { Route } from '@angular/router';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { environment } from '../environments/environment';
import * as fromArticles from './articles';
import * as fromAuth from './auth';
import * as fromChats from './chats';
import { provideSpeechToText } from './chats/request';
import * as fromLayout from './layout';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login.page').then((m) => m.LoginPage),
    // canActivate: [fromAuth.loginGuard],
    data: { animationState: 'login' },
  },
  {
    path: '',
    canActivate: [fromAuth.authGuard],
    canActivateChild: [fromAuth.authGuard],
    providers: [
      provideState(fromLayout.layoutFeature),
      provideState(fromChats.chatsFeature),
      provideEffects(fromChats.ChatsEffects),
      provideState(fromArticles.articlesFeature),
      provideEffects(fromArticles.ArticlesEffects),
      fromChats.ChatsSocket,
    ],
    loadComponent: () => import('./layout/layout.page').then((m) => m.LayoutPage),
    data: { animationState: 'main' },
    children: [
      {
        path: '',
        redirectTo: 'request',
        pathMatch: 'full',
      },
      {
        path: 'request',
        providers: [provideSpeechToText(environment.speechToTextProvider)],
        loadComponent: () => import('./chats/request/request.page').then((m) => m.RequestPage),
        data: { title: 'New Request' },
      },
      {
        path: 'articles',
        children: [
          {
            path: '',
            loadComponent: () => import('./articles/article-list.component').then((m) => m.ArticleListComponent),
            data: { title: 'Articles' },
          },
          {
            path: ':node_id',
            loadComponent: () => import('./articles/article-detail.page').then((m) => m.ArticleDetailPageComponent),
            data: { title: 'Article Detail' },
          },
        ],
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./not-found.page').then((m) => m.NotFoundPage),
    data: { title: 'Not Found' },
  },
];
